// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Br1U","productName":"Table_productName__3Abov"};